import { FORMAT_C3_ASSET_ID, FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import { MetadataValueTypes } from '@cube3/common/model/schema/resources/metadata-field-type';
import { FieldType, Value } from '@cube3/forms/src/types/GenericFormTypes';
import { getFieldValue } from '@cube3/forms/src/utils/getFieldValue';

import { validate } from 'jsonschema';
// export const fieldTypeSchemas = {
//   string: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       minLength: {
//         type: 'number',
//         minimum: 0

//       },
//       maxLength: {
//         type: 'number',
//         minimum: 1
//       },
//       pattern: {
//         type: 'string',
//         format: 'regex'
//       }
//     },
//     required: ['type']
//   },
//   text: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       minLength: {
//         type: 'number',
//         minimum: 0

//       },
//       maxLength: {
//         type: 'number',
//         minimum: 1
//       },
//       pattern: {
//         type: 'string',
//         format: 'regex'
//       }
//     },
//     required: ['type']
//   },
//   textarea: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       minLength: {
//         type: 'number',
//         minimum: 0
//       },
//       maxLength: {
//         type: 'number',
//         minimum: 1
//       },
//       pattern: {
//         type: 'string',
//         format: 'regex'
//       }
//     },
//     required: ['type']
//   },
//   number: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'number'
//       },
//       minimum: {
//         type: 'number'
//       },
//       maximum: {
//         type: 'number'
//       },
//       multipleOf: {
//         type: 'number'
//       }
//     },
//     required: ['type']
//   },
//   email: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       format: {
//         const: 'email'
//       }
//     },
//     required: ['type']
//   },
//   checkbox: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         enum: ['array', 'boolean']
//       },
//     },
//     if: {
//       properties: {
//         type: { const: 'array' }
//       }
//     },
//     then: {
//       properties: {
//         items: {
//           type: 'object',
//           properties: {
//             type: { const: 'string' },
//             enum: {
//               type: 'array',
//               items: { type: 'string' }
//             }
//           }
//         },
//         maxLength: { type: 'number', minimum: 0 }
//       },
//       required: ['type', 'items']
//     },
//     required: ['type']
//   },
//   select: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//     },
//     required: ['type']
//   },
//   date: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       format: {
//         enum: ['date-time', FORMAT_C3_YEAR_DATE]
//       },
//       minDate: {
//         type: 'string',
//         format: 'date',
//       }
//     },
//     required: ['type', 'format']
//   },
//   multiselect: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'array'
//       },
//       items: {
//         type: 'object',
//         properties: {
//           type: { const: 'string' },
//           enum: {
//             type: 'array',
//             items: { type: 'string' }
//           }
//         }
//       },
//       maxLength: { type: 'number', minimum: 0 },
//     },
//     required: ['type', 'items']

//   },
//   phone_number: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'string'
//       },
//       pattern: {
//         type: 'string',
//         format: 'regex'
//       },
//     },
//     required: ['type', 'pattern']
//   },
//   recipients: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'array'
//       },
//       items: {
//         type: 'object',
//         properties: {
//           type: { const: 'string' },
//           format: { const: 'email' }
//         }
//       },
//       maxLength: { type: 'number', minimum: 0 },
//     },
//     required: ['type', 'items']
//   },
//   asset: {
//     $schema: 'https://json-schema.org/draft/2019-09/schema',
//     type: 'object',
//     properties: {
//       type: {
//         const: 'array'
//       },
//       items: {
//         type: 'object',
//         properties: {
//           type: { const: 'string' },
//         }
//       },
//     },
//     required: ['type', 'items']
//   },
//   waterfall_select: {
//     //TODO?
//   },
//   resource_picker: {
//     //TODO?
//   },
//   expires_at: {
//     //TODO?
//   }
// };

const schemaKeyPair = {
  min: 'minimum',
  max: 'maximum',
  step: 'multipleOf',
  maxLength: 'maxLength',
  minLength: 'minLength'
};

const makeEnum = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((v) => v.id || v);
  }
  return value;
};

/** Helper function to generate `json_schema` from field settings */
export const makeSchema = (value: Array<Value>, type: FieldType, fieldTypeSchemas: Record<MetadataValueTypes, string>) => {
  const schema = value.reduce((acc, item) => {
    const key = schemaKeyPair[item.id];
    if (key) {
      acc[key] = item.value ? Number(item.value || '') : item.value;
    } else {
      switch (item.id) {
        case 'yearOnly':
          acc['type'] = 'string'
          acc['format'] = item.value ? FORMAT_C3_YEAR_DATE : 'date-time';
          break;
        case 'options':
          switch (type) {
            case 'select':
              acc['enum'] = makeEnum(item.value);
              break
            case 'waterfall_select':
              acc['type'] = 'object';
              acc["minProperties"] = 1;
              acc["maxProperties"] = 1;
              acc['properties'] = {}
              {
                try {
                  makeWaterfallSchemaProperties(item.value, acc)
                } catch (e) {
                  acc['properties']['error'] = { type: "array", items: { type: "string", enum: [e.toString()] }, optional: true, miniItems: 0 }
                }
              }
              break
            case 'multiselect':
              acc['type'] = 'array';
              acc['items'] = { type: 'string', enum: makeEnum(item.value) };
              acc['uniqueItems'] = true
              break;
            default:
              acc['type'] = 'array';
              acc['items'] = { type: 'string', enum: makeEnum(item.value) };
          }
          break;
        case 'required':
          break;
        case 'multiple':
          break;

        default:
          acc[item.id] = item.value;
          break;
      }
    }
    return acc;
  }, { type: 'string' });

  switch (type) {
    case 'checkbox': {
      if (type === 'checkbox' && !getFieldValue(value, 'multiple').value) {
        // if the `multiple` is false, should clear the options
        schema['type'] = 'boolean';
        delete schema['items']
      }
      break;
    }
    case 'number':
      schema['type'] = 'number'
      break;
    case 'phone_number':
      schema['pattern'] = "^[\\d+-]{3,14}$"
      break;
    case 'recipients':
      schema['type'] = 'array'
      schema['items'] = { type: 'string', format: 'email' };
      break;
    case 'asset':
      schema['type'] = 'array'
      schema['items'] = { type: 'string', format: FORMAT_C3_ASSET_ID };
      break
    default:
      break;
  }

  const validationSchema = fieldTypeSchemas[type];

  if (validationSchema) {
    console.info("DEBUG makeschema ", type, schema)
    const v = validate(schema, JSON.parse(validationSchema), { allowUnknownAttributes: false, throwAll: false })
    console[v.errors.length ? 'error' : 'info']("DEBUG makeschema res ", v)
  } else {
    console.info("DEBUG makeschema no schema for type", type)
  }
  return schema;
};


export const makeWaterfallSchemaProperties = (value, acc) => {
  const json = JSON.parse(value as string)
  if (typeof json != 'object' || json === null) {
    throw new Error(`Invalid options`)
  }
  Object.keys(json).forEach(
    l1 => {
      if (!Array.isArray(json[l1]) || json[l1].some(e => typeof e !== 'string')) {
        throw new Error(`Invalid sub options for option ${l1}`)
      }
      acc['properties'][l1] = {
        type: 'array',
        items: {
          type: 'string',
          enum: makeEnum(json[l1])
        },
        optional: json[l1].length < 1,
        minItems: json[l1].length < 1 ? undefined : 1
      }
    })
}